import { render, staticRenderFns } from "./NotificationDispatcher.vue?vue&type=template&id=67fd3ed4&scoped=true&"
import script from "./NotificationDispatcher.vue?vue&type=script&lang=js&"
export * from "./NotificationDispatcher.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDispatcher.vue?vue&type=style&index=0&id=67fd3ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd3ed4",
  null
  
)

/* custom blocks */
import block0 from "./NotificationDispatcher.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fd3ed4')) {
      api.createRecord('67fd3ed4', component.options)
    } else {
      api.reload('67fd3ed4', component.options)
    }
    module.hot.accept("./NotificationDispatcher.vue?vue&type=template&id=67fd3ed4&scoped=true&", function () {
      api.rerender('67fd3ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/NotificationDispatcher.vue"
export default component.exports